import gql from 'graphql-tag'

export default gql`
	query getDataGridImport {
		cashAssist {
			listCategories {
				items {
					id
					name
				}
			}

			listSalesGroups {
				items {
					id
					name
				}
			}
		}
	}`
